module.exports = __webpack_public_path__ + "media/images/lb/532-6500005ca81ed1d6df59dd586c93ee28.svg";